import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Planner from '@/components/Planner/Planner'
import Home from '@/components/Home'
import Users from '@/components/Users/Users'
import Reservations from '@/components/Reservations/Reservations'
import History from '@/components/History/History'
import Units from '@/components/Units/Units'
import Dashboard from '@/components/Dashboard/Dashboard'
import Prices from '@/components/Prices/Prices'
import Settings from '@/components/Settings'
import TestDrive from '@/components/TestDrives/TestDrive'
import AdditionalItems from '@/components/Reservations/AdditionalItems'
import Messages from '@/components/Messages'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'Login_base',
			component: Login
		},
		{
			path: '/login/:action?',
			name: 'Login',
			component: Login
		},
		{
			path: '/logout',
			name: 'Logout',
			redirect: {
				name: 'Login',
				params: {
					action: '-'
				}
			}
		},
		{
			path: '/reservations',
			name: 'Home',
			component: Reservations
		},
		{
			path: '/dashboard',
			name: 'Dashboard',
			component: Dashboard,
		},
		{
			path: '/update',
			name: 'Update',
			component: Settings,
		},
		{
			path: '/reservations/',
			name: 'Reservations',
			component: Reservations,
		}, {
			path: '/reservations/:id',
			name: 'Reservations_details',
			component: Reservations,
		},
		{
			path: '/planner',
			name: 'Planner',
			component: Planner
		},
		{
			path: '/users',
			name: 'Users',
			component: Users
		},
		{
			path: '/users/:userid',
			name: 'showUser',
			component: Users
		},
		{
			path: '/history',
			name: 'History',
			component: History
		}, {
			path: '/history/:id',
			name: 'History_details',
			component: History
		},
		{
			path: '/units',
			name: 'Units',
			component: Units
		},
		{
			path: '/prices',
			name: 'Prices',
			component: Prices
		},
		{
			path: '/additionalItems',
			name: 'AdditionalItems',
			component: AdditionalItems
		},
		{
			path: '/settings',
			name: 'Settings',
			component: Settings
		},
		{
			path: '/testdrive',
			name: 'TestDrive',
			component: TestDrive
		},
		{
			path: '/messages',
			name: 'Messages',
			component: Messages
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js